import React from 'react'
import './onebluecard.scss'
import { Row, Col, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import { images } from '../../../utils/customFn';
const LetsTalk = () => {
    return (
        <div className='lets-talk-wrapper'>
            <Row>
                <Col sm={12} md={8} lg={8} xl={8}>
                    <div className='talk-form-main'>
                        <div className='top-heading'>
                            <h3>Let’s talk</h3>
                            <p>Ready to get the conversation started? Fill out the form below. We'll be in touch soon.</p>
                        </div>
                        <Form>
                            <Row>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Name*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Email*</Form.Label>
                                        <Form.Control type="email" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Comments</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>
                            <div className='term-condition'>
                              <p>By pressing submit form, you agree that the information you are providing is your own and we may use the information you provide according to our <a href="https://www.sentry.com/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a> and <a href="https://www.sentry.com/terms-and-conditions" rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a>.</p>
                            </div>
                            <div className='bottom-btn'>
                                <Button className='submit-btn' type="submit">
                                    Submit form
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col sm={12} md={4} lg={4} xl={4}>
                   <div className='media-img'>
                      <img src={images['GolfBallTees.avif']} alt="media" />
                   </div>
                </Col>
            </Row>
        </div>
    )
}

export default LetsTalk